import {
  Archive,
  ArchiveX,
  ArrowBigDownDash,
  ArrowDownWideNarrow,
  ArrowsUpFromLine,
  ArrowUpDown,
  BarChart,
  Bell,
  Book,
  Building2,
  Cable,
  Calendar,
  CircleX,
  CheckCircle,
  CheckIcon,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsRight,
  ChevronsUpDown,
  ChevronUp,
  Circle,
  CircleGauge,
  CircleMinus,
  CircleOff,
  CircleUser,
  ClipboardPaste,
  Clock,
  Command,
  Copy,
  CreditCard,
  Dot,
  Download,
  Edit,
  Ellipsis,
  FileClock,
  FileScan,
  Filter,
  FilePieChart,
  FileLineChart,
  Gauge,
  HandCoins,
  Home,
  Hourglass,
  Key,
  Layers,
  LineChart,
  ListFilter,
  LoaderCircle,
  LogOut,
  Logs,
  Mail,
  Map,
  MapPin,
  MapPinned,
  Menu,
  Minus,
  Moon,
  MoveRight,
  Notebook,
  NotebookText,
  NotepadText,
  Package,
  Package2,
  PanelsTopLeft,
  PartyPopper,
  Phone,
  Plus,
  Power,
  Ruler,
  Search,
  Settings,
  Share,
  Send,
  ShoppingCart,
  Smartphone,
  Square,
  SunMedium,
  Trash,
  Unplug,
  User,
  UserCircle,
  UserPlus,
  Users,
  View,
  Volume2,
  X,
  UserCog,
  CalendarClock,
  Plug,
  PlugZap,
  MessageSquare,
  Upload,
  Boxes,
  BookUser,
  UserSearch,
  Proportions,
  ScanLine
} from "lucide-react"
import { IoPeopleOutline, IoSpeedometerOutline } from "react-icons/io5"
import { LiaMoneyBillWaveAltSolid } from "react-icons/lia"
import { MdOutlineDashboard } from "react-icons/md"
import { TbReportSearch } from "react-icons/tb"

import rightArrow from "@/components/assets/Arrow External Right.svg"
import attachImage from "@/components/assets/attachImage.svg"
import attachment from "@/components/assets/attachmentIcon.svg"
import calendarDark from "@/components/assets/calendarDark.png"
import emoji from "@/components/assets/emojiIcon.svg"
import font from "@/components/assets/fontIcon.svg"
import insertLink from "@/components/assets/insertLinkIcon.svg"
import label from "@/components/assets/labelIcon.svg"
import pinDark from "@/components/assets/Map Pin Icon.png"
import octiconMeter from "@/components/assets/octicon_meter-16.svg"
import person from "@/components/assets/person.svg"
import personDark from "@/components/assets/personDarkMode.png"
import sign from "@/components/assets/signIcon.svg"
import statusDark from "@/components/assets/statusDark.png"

import "lucide-react"

import BubbleIcon1 from "./assets/bubble1.png"
import BubbleIcon1Dark from "./assets/bubble1Dark.png"
import BubbleIcon2 from "./assets/bubble2.svg"
import BubbleIcon2Dark from "./assets/bubble2Dark.svg"
import BubbleIcon3 from "./assets/bubble3.png"
import BubbleIcon3Dark from "./assets/bubble3Dark.png"
import loginCardIcon from "./assets/cardlogo.svg"
import loginCardIcon2 from "./assets/cardlogo2.svg"
import ellipse from "./assets/Ellipse.png"
import ellipseDark from "./assets/EllipseDark.png"
import hirayaIcon from "./assets/logo/Hiraya_Tech-Icon.png"
import hirayaWText from "./assets/logo/logo_with_text.png"
import phoneDark from "./assets/phoneDark.png"
import phoneTrusted from "./assets/phoneTrustedDark.png"
import redDot from "./assets/redDot.png"

export type IconKeys = keyof typeof icons

type IconsType = {
  [key in IconKeys]: React.ElementType
}

type IconProps = React.HTMLAttributes<SVGElement>
type ImgProps = React.ImgHTMLAttributes<HTMLImageElement>

const icons = {
  // Login icons bubble and other login icons
  cardloginicon: (props: ImgProps) => (
    <img src={loginCardIcon} alt="cardloginicon" {...props} />
  ),
  cardloginicon2: (props: ImgProps) => (
    <img src={loginCardIcon2} alt="cardloginicon" {...props} />
  ),
  ellipseDark: (props: ImgProps) => (
    <img src={ellipseDark} alt="EllipseDark" {...props} />
  ),
  ellipse: (props: ImgProps) => <img src={ellipse} alt="Ellipse" {...props} />,
  bubble1Dark: (props: ImgProps) => (
    <img src={BubbleIcon1Dark} alt="BUBBLEDARK" {...props} />
  ),
  bubble1: (props: ImgProps) => (
    <img src={BubbleIcon1} alt="BUBBLE" {...props} />
  ),
  bubble2Dark: (props: ImgProps) => (
    <img src={BubbleIcon2Dark} alt="BUBBLE" {...props} />
  ),
  bubble2: (props: ImgProps) => (
    <img src={BubbleIcon2} alt="BUBBLE" {...props} />
  ),
  bubble3: (props: ImgProps) => (
    <img src={BubbleIcon3} alt="BUBBLE" {...props} />
  ),
  bubble3Dark: (props: ImgProps) => (
    <img src={BubbleIcon3Dark} alt="BUBBLE" {...props} />
  ),

  // Verification Icons
  phoneDark: (props: ImgProps) => (
    <img src={phoneDark} alt="Phone" {...props} />
  ),
  phoneTrustedDark: (props: ImgProps) => (
    <img src={phoneTrusted} alt="Phone" {...props} />
  ),
  redDot: (props: ImgProps) => <img src={redDot} alt="Phone" {...props} />,

  // Hiraya
  himo: (props: ImgProps) => <img src={hirayaIcon} alt="HIMO" {...props} />,
  hirayaWText: (props: ImgProps) => (
    <img src={hirayaWText} alt="HIMO with Text" {...props} />
  ),

  person: (props: ImgProps) => <img src={person} alt="Person" {...props} />,
  personDark: (props: ImgProps) => (
    <img src={personDark} alt="Person" {...props} />
  ),
  calendarDark: (props: ImgProps) => (
    <img src={calendarDark} alt="Calendar" {...props} />
  ),
  pinDark: (props: ImgProps) => <img src={pinDark} alt="Pin" {...props} />,
  statusDark: (props: ImgProps) => (
    <img src={statusDark} alt="Status" {...props} />
  ),
  rightArrow: (props: ImgProps) => (
    <img src={rightArrow} alt="Right rrow" {...props} />
  ),
  octiconMeter: (props: ImgProps) => (
    <img src={octiconMeter} alt="Meter" {...props} />
  ),

  font: (props: ImgProps) => <img src={font} alt="font" {...props} />,
  attachment: (props: ImgProps) => (
    <img src={attachment} alt="attachment" {...props} />
  ),
  insertLink: (props: ImgProps) => (
    <img src={insertLink} alt="insertLink" {...props} />
  ),
  emoji: (props: ImgProps) => <img src={emoji} alt="emoji" {...props} />,
  attachImage: (props: ImgProps) => (
    <img src={attachImage} alt="attach image" {...props} />
  ),
  sign: (props: ImgProps) => <img src={sign} alt="sign" {...props} />,
  label: (props: ImgProps) => <img src={label} alt="label" {...props} />,
  // Menu
  map: Map,
  profile: UserCircle,
  "sms-blast": Volume2,
  billing: LiaMoneyBillWaveAltSolid,
  "manage-user": IoPeopleOutline,
  report: TbReportSearch,
  dashboard: MdOutlineDashboard,
  building2: Building2,
  cable: Cable,
  ScanLine: ScanLine,



  // General
  Proportions: Proportions,
  Dot: Dot,
  CircleOff: CircleOff,
  ArrowBigDownDash: ArrowBigDownDash,
  Unplug: Unplug,
  ArrowsUpFromLine: ArrowsUpFromLine,
  partyPopper: PartyPopper,
  logo: Command,
  sun: SunMedium,
  moon: Moon,
  moveRight: MoveRight,
  home: Home,
  users: Users,
  bell: Bell,
  circleUser: CircleUser,
  lineChart: LineChart,
  menu: Menu,
  package: Package,
  package2: Package2,
  search: Search,
  shoppingCart: ShoppingCart,
  mixer: ArrowDownWideNarrow,
  sort: ArrowUpDown,
  download: Download,
  upload:Upload,
  checkCircle: CheckCircle,
  filter: Filter,
  listFilter: ListFilter,
  settings: Settings,
  calendar: Calendar,
  loader: LoaderCircle,
  panelsTopLeft: PanelsTopLeft,
  layers: Layers,
  notepad: NotepadText,
  notebook: NotebookText,
  book: Book,
  user: User,
  FileClock: FileClock,
  peso: (props: IconProps) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-philippine-peso"
        {...props}
      >
        <path d="M20 11H4" />
        <path d="M20 7H4" />
        <path d="M7 21V4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 12H7" />
      </svg>
    )
  },
  HandCoins: HandCoins,
  ellipsis: Ellipsis,
  creditCard: CreditCard,
  key: Key,
  mapPin: MapPin,
  phone: Phone,
  mail: Mail,
  fileScan: FileScan,
  logout: LogOut,
  cmd: Command,
  gauge: IoSpeedometerOutline,
  smartphone: Smartphone,
  clock: Clock,
  share: Share,
  send: Send,
  filePie: FilePieChart,
  fileline: FileLineChart,

  // Operations
  view: View,
  add: Plus,
  edit: Edit,
  delete: Trash,
  archive: Archive,
  copy: Copy,
  paste: ClipboardPaste,

  // Chevrons
  up: ChevronUp,
  down: ChevronDown,
  right: ChevronRight,
  doubleRight: ChevronsRight,
  left: ChevronLeft,
  updown: ChevronsUpDown,

  // Diagram Icons
  circleMinus: CircleMinus,
  minus: Minus,
  square: Square,
  circleX:CircleX,

  userPlus: UserPlus,
  plus: Plus,
  circleGauge: CircleGauge,
  check: CheckIcon,
  x: X,
  power: Power,
  circle: Circle,
  hourglass: Hourglass,
  ruler: Ruler,
  barChart: BarChart,

  // Sidebar Icons
  zones: MapPin,
  meterSize: Ruler,
  meterReader: Users,
  bookZone: Book,
  connectionRate: Gauge,
  policyDate: CalendarClock,
  connectionStatus: Plug,
  connectionType: PlugZap,
  smsTemplate: MessageSquare,
  emailTemplate: Mail,
  UserCog: UserCog,
  billingUser: UserSearch,
  department: Boxes,
  position: BookUser,
  tracker: MapPinned,

}

export const Icons: IconsType = icons
